import type { GroupUser } from "@api/groups/types";
import type { User } from "@api/user/types";
import { useContext } from "solid-js";
import { groupRolesContext } from "../..";

/**
 * Used to generate a user with zero permissions, the user role `user_read_only` is probably
 * static and could be used instead of searching for a role with zero permissions but this
 * is slightly better in my opinion when someone decides to rename the role
 */
const useFallbackUser = () => {
	const roles = useContext(groupRolesContext);
	return (user: User): GroupUser => ({ role_id: roles.find((role) => role.permissions.length === 0)?.id ?? "", user });
};
export default useFallbackUser;
